<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listado" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :cliente="item"></opciones>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoFuncionariosDesktop',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
